import { useI18n } from 'vue-i18n';

export enum AuthErrorCode {
  GOOGLE_USER_DATA_FAILED = 100,
  EMPTY_INVITE_CODE = 101,
  INVALID_INVITE_CODE = 102,
  USED_INVITE_CODE = 103,
  USER_CREATION_FAILED = 104,
  TOKEN_CREATION_FAILED = 105,
  OTHER_LOGIN_FAILED = 106,
}

export interface ErrorCodeInfo {
  code: AuthErrorCode;
  message: string;
  redirectType: 'login' | 'signup';
}

export const getAuthErrorCodes = (err_code: AuthErrorCode): ErrorCodeInfo => {
  const { t } = useI18n();
  switch (err_code) {
    case AuthErrorCode.GOOGLE_USER_DATA_FAILED:
      return {
        code: AuthErrorCode.GOOGLE_USER_DATA_FAILED,
        message: t('errorMessages.googleUserDataFailed'),
        redirectType: 'login',
      };
    case AuthErrorCode.EMPTY_INVITE_CODE:
      return {
        code: AuthErrorCode.EMPTY_INVITE_CODE,
        message: t('errorMessages.emptyInviteCode'),
        redirectType: 'signup',
      };
    case AuthErrorCode.INVALID_INVITE_CODE:
      return {
        code: AuthErrorCode.INVALID_INVITE_CODE,
        message: t('errorMessages.invalidInviteCode'),
        redirectType: 'signup',
      };
    case AuthErrorCode.USED_INVITE_CODE:
      return {
        code: AuthErrorCode.USED_INVITE_CODE,
        message: t('errorMessages.usedInviteCode'),
        redirectType: 'signup',
      };
    case AuthErrorCode.USER_CREATION_FAILED:
      return {
        code: AuthErrorCode.USER_CREATION_FAILED,
        message: t('errorMessages.userCreationFailed'),
        redirectType: 'signup',
      };
    case AuthErrorCode.TOKEN_CREATION_FAILED:
      return {
        code: AuthErrorCode.TOKEN_CREATION_FAILED,
        message: t('errorMessages.tokenCreationFailed'),
        redirectType: 'login',
      };
    case AuthErrorCode.OTHER_LOGIN_FAILED:
      return {
        code: AuthErrorCode.OTHER_LOGIN_FAILED,
        message: t('errorMessages.otherLoginFailed'),
        redirectType: 'login',
      };
    default:
      return {
        code: AuthErrorCode.OTHER_LOGIN_FAILED,
        message: t('errorMessages.otherLoginFailed'),
        redirectType: 'login',
      };
  }
};
